export {
  GetFullMonthList,
  GetLabelForMonth,
  GetMonthRangeLabel
}

function GetFullMonthList(){
  const year = new Date().getFullYear();
  const monthList = [...Array(12).keys()]; 
  
  const formatter = new Intl.DateTimeFormat("de", {
    month: "long"
  });

  const getMonthName = (monthIndex) =>
    formatter.format(new Date(year, monthIndex));

  return monthList.map(x => { return { id: x, text: getMonthName(x) } });
}

function GetLabelForMonth(monthIndex) {
  const year = new Date().getFullYear();
  const formatter = new Intl.DateTimeFormat("de", {
    month: "long"
  });

  return formatter.format(new Date(year, monthIndex));
}

function GetMonthRangeLabel(validFrom, validTo) {
  const fromMonth = validFrom ? new Date(validFrom).getMonth() : null;
  const toMonth = validTo ? new Date(validTo).getMonth() : null;
  const year = validFrom ? new Date(validFrom).getFullYear() : null;

  if (fromMonth == null && toMonth == null) {
    return "";
  }
  if (toMonth == null) {
    return `ab ${GetLabelForMonth(fromMonth)}`;
  }
  if(fromMonth === toMonth) {
    return GetLabelForMonth(fromMonth);
  }
  return `${GetLabelForMonth(fromMonth)}–${GetLabelForMonth(toMonth)} ${year}`;
}